export default __webpack_public_path__ + "static/media/checklist.86731b78.png";